// src/js/helpers/cart-badge.js
// Lightweight module exposing plancUpdateCartBadge if not present
export default function installCartBadge() {
  if (typeof window.plancUpdateCartBadge !== 'function') {
    window.plancUpdateCartBadge = function(a, b, _c) {
      try {
        if (a && typeof a === 'object') {
          Object.keys(a).forEach(function(key) {
            try {
              var html = a[key];
              document.querySelectorAll(key).forEach(function(node) {
                var wrapper = document.createElement('div');
                wrapper.innerHTML = html;
                var replacement = wrapper.firstElementChild || wrapper;
                node.replaceWith(replacement);
              });
            } catch (e) { if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('planc: fragment replace failed for', key, e); }
          });
          return;
        }

        var count = null;
        if (a === null && typeof b !== 'undefined') {
          count = parseInt(b, 10);
        } else if (typeof a === 'number' || (typeof a === 'string' && !isNaN(parseInt(a,10)))) {
          count = parseInt(a,10);
        }
        if (isNaN(count)) return;
        var applyNumeric = function(el, value) {
          if (!el) return;
          try {
            if (value > 0) {
              el.textContent = value;
              el.classList.remove('hidden');
            } else {
              el.textContent = '0';
              el.classList.add('hidden');
            }
          } catch (e) {
            if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('planc: applyNumeric failed', e);
          }
        };
        applyNumeric(document.getElementById('cart-badge'), count);
        applyNumeric(document.getElementById('mobile-cart-badge') || document.querySelector('.mobile-cart-badge'), count);
        document.querySelectorAll('.cart-count, .cart-contents-count').forEach(function(node){ try { node.textContent = '' + count; } catch(e){ if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('planc: cart-count apply failed', e); } });

      } catch (err) { if (window.PLANC_DEBUG && typeof console !== 'undefined') console.debug('plancUpdateCartBadge error', err); }
    };
  }
}
